import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '../../shared/src/environments/environment';
import * as useIcons from './use-icons';

if (environment.production) {
  enableProdMode();
}
addIcons(environment.production ? useIcons : allIcons);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err));
